import type {
  Complement,
  ProjectItem,
  ProjectItemDraft,
} from '@customink/project-service-react-components';
import { useDesignHasSleeve } from '@customink/project-service-react-components';
import type { ReactEventHandler } from 'react';
import { useState } from 'react';

import ComplementsAccordion from '../Complements/ComplementsAccordion';
import ComplementsBox from '../Complements/ComplementsBox';
import ProjectItemAddModal from '../ProjectItem/ProjectItemAddModal';

import { useOpenCatalogIframe } from '@/components/CatalogIframe';
import { useHasMultipleDesigns } from '@/hooks/Design';
import { useFilteredComplements } from '@/hooks/Product/useFilteredComplements';
import { useAnchorProduct } from '@/hooks/useAnchorProduct';

type GroupComplementsProps = {
  projectItems: ProjectItem[];
};

export default function GroupComplements({
  projectItems,
}: GroupComplementsProps) {
  const referenceProjectItem = projectItems[0];
  const designCid = referenceProjectItem.design?.cid;
  const hasMultipleDesigns = useHasMultipleDesigns();
  const onOpenCatalogIframe = useOpenCatalogIframe();

  const anchorProduct = useAnchorProduct(designCid || '');
  const compatible_type = anchorProduct?.compatible_type;

  const [selectedComplementColorId, setSelectedComplementColorId] =
    useState<number>();

  const hasSleeveDesign = useDesignHasSleeve(designCid || '');

  const onAddCompatible = () => {
    onOpenCatalogIframe({ designCid, filters: { compatible_type } });
  };

  const filteredComplements = useFilteredComplements(projectItems || []);

  const draftProjectItem: ProjectItemDraft = {
    design: { cid: designCid },
    fulfillment: {
      priority: referenceProjectItem?.fulfillment?.priority,
    },
  };

  const handleComplementClick = (complement: Complement) => {
    setSelectedComplementColorId(complement.colorId);
  };

  const handleAddModalClose: ReactEventHandler = () => {
    setSelectedComplementColorId(undefined);
  };

  if (!projectItems?.length || !filteredComplements?.length) return null;

  const showAccordion = !hasSleeveDesign && hasMultipleDesigns;

  return (
    <>
      {showAccordion ? (
        <ComplementsAccordion
          onAddCompatible={onAddCompatible}
          onSelectComplement={handleComplementClick}
          projectItems={projectItems}
        />
      ) : (
        <ComplementsBox
          onAddCompatible={onAddCompatible}
          onSelectComplement={handleComplementClick}
          projectItems={projectItems}
        />
      )}
      {selectedComplementColorId && (
        <ProjectItemAddModal
          draftProjectItem={{
            ...draftProjectItem,
            product: { colorId: selectedComplementColorId },
          }}
          onClose={handleAddModalClose}
          persistSelectedColor
        />
      )}
    </>
  );
}
